/**
 * @flow
 * @relayHash 99564c9ff5c544990a5531ff181ea3d5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BlocCopiesQueryVariables = {|
  tenantPks: $ReadOnlyArray<?number>,
  excludeBlocPk: number,
|};
export type BlocCopiesQueryResponse = {|
  +blocCopies: ?{|
    +duplicateFound: ?boolean,
    +blocs: ?$ReadOnlyArray<?any>,
    +error: ?{|
      +statusCode: ?number,
      +message: ?string,
    |},
  |}
|};
export type BlocCopiesQuery = {|
  variables: BlocCopiesQueryVariables,
  response: BlocCopiesQueryResponse,
|};
*/


/*
query BlocCopiesQuery(
  $tenantPks: [Int]!
  $excludeBlocPk: Int!
) {
  blocCopies(tenantPks: $tenantPks, excludeBlocPk: $excludeBlocPk) {
    duplicateFound
    blocs
    error {
      statusCode
      message
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "tenantPks",
    "type": "[Int]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "excludeBlocPk",
    "type": "Int!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "blocCopies",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "excludeBlocPk",
        "variableName": "excludeBlocPk",
        "type": "Int!"
      },
      {
        "kind": "Variable",
        "name": "tenantPks",
        "variableName": "tenantPks",
        "type": "[Int]!"
      }
    ],
    "concreteType": "BlocCopiesType",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "duplicateFound",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "blocs",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "error",
        "storageKey": null,
        "args": null,
        "concreteType": "ErrorType",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "statusCode",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "BlocCopiesQuery",
  "id": "65eacd39d6bf08f075da815e0aae8fe4",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "BlocCopiesQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "BlocCopiesQuery",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
node.text = "query BlocCopiesQuery(\n  $tenantPks: [Int]!\n  $excludeBlocPk: Int!\n) {\n  blocCopies(tenantPks: $tenantPks, excludeBlocPk: $excludeBlocPk) {\n    duplicateFound\n    blocs\n    error {\n      statusCode\n      message\n    }\n  }\n}\n";
(node/*: any*/).hash = 'baf9c5eaef1e524d6c83784e19da38d8';
module.exports = node;
